var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeniority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.13 62.9599C48.3226 62.9599 62.26 49.0226 62.26 31.83C62.26 14.6373 48.3226 0.699951 31.13 0.699951C13.9374 0.699951 0 14.6373 0 31.83C0 49.0226 13.9374 62.9599 31.13 62.9599Z",
    fill: "#853088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.91 23.61H16.89V27.93H44.91V23.61Z",
    stroke: "white",
    strokeWidth: 3.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.49 27.9399H19.14V45.5799H42.49V27.9399Z",
    stroke: "white",
    strokeWidth: 3.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.82 23.61C30.82 23.61 36.27 14.62 38.34 17.9C38.34 17.9 41.11 20.67 30.82 23.61Z",
    stroke: "white",
    strokeWidth: 3.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9 23.61C30.9 23.61 25.45 14.62 23.38 17.9C23.38 17.9 20.61 20.67 30.9 23.61Z",
    stroke: "white",
    strokeWidth: 3.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeniority);
export default __webpack_public_path__ + "static/media/seniority.f1c3777294a0b64469c6b41f95c7f97c.svg";
export { ForwardRef as ReactComponent };